import useFleetStore from "../../utils/store";
import BasePodModal from "./BasePodModal";
import {updateFleet} from "../../lib/api";
import {WEATHER_WIDGET_PROVIDERS} from "../../utils/constants";

export default function EditPodModal({ podData, setShowPodModal, onEditSuccess }) {
    const { setSelectedFleet } = useFleetStore();
    const isUsingDeprecatedWeatherWidget = podData?.data?.zone?.weatherWidgetProvider === WEATHER_WIDGET_PROVIDERS.WEATHER_WIDGET_DOT_ORG;
    const initialFormData = {
        name: podData?.data?.zone?.name || '',
        timeZone: podData?.data?.zone?.timeZone || '',
        weatherWidgetId: isUsingDeprecatedWeatherWidget ? '' : podData?.data?.zone?.weatherWidgetId || '',
        cityName: isUsingDeprecatedWeatherWidget ? '' : podData?.data?.zone?.cityName || '',
    };
    const onSuccess = async (newFleet) => {
        setSelectedFleet(newFleet);
        setShowPodModal(false);
        if (typeof onEditSuccess === "function") {
            onEditSuccess();
        }
    };
    const apiMethod = async (formData) => {
        return await updateFleet({unid: podData?.data?.zone?.unid}, formData);
    }
    const additionalValidationFunc = (formData) => {
        const isDataChanged = (
          formData.name !== initialFormData.name ||
          formData.timeZone !== initialFormData.timeZone ||
          formData.weatherWidgetId !== initialFormData.weatherWidgetId ||
          formData.cityName !== initialFormData.cityName
        );
        const newErrors = {};
        if (isUsingDeprecatedWeatherWidget && formData.cityName.length === 0) {
            newErrors.city = 'We have migrated weather forecast providers. Please update your zone\'s location.';
        }
        return {
            isValid: isDataChanged && Object.keys(newErrors).length === 0,
            errors: newErrors
        }
    }
    return <BasePodModal
        initialFormData={initialFormData}
        apiMethod={apiMethod}
        title="Edit Zone"
        buttonText="Save"
        shouldFocusOnNameField={false}
        hideModal={() => setShowPodModal(false)}
        additionalValidationFunc={additionalValidationFunc}
        onSuccess={onSuccess} />;
}